/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import {useEffect} from 'react';
import * as ReactDOM from 'react-dom';
import {useDispatch, useSelector} from "react-redux";
import {OptionalBundleRow} from "../lists/OptionalBundleRow";
import {useI18N} from "../../hoc/withI18N";
import {PromoLabel} from "../promotions/promo-label/PromoLabel";
import {getFallbackImage} from "../../../selectors/generic";
import {getActiveSku} from "../../../selectors/productPage";
import {fetchBundles} from "../../../actions/my-puratos/promotions.action";
import {selectAllBundlesProducts} from "../../../selectors/my-puratos/promotions";

const target = document.getElementById("react-product--bundles");

export const BundleSelector = () => {

    const translate = useI18N();
    const dispatch = useDispatch();
    const fallbackImage = useSelector(state => getFallbackImage(state));
    const activeSku = useSelector(getActiveSku);
    const bundles = useSelector(selectAllBundlesProducts) || [];

    const isSkuInBundle = React.useMemo(() => bundles?.filter(bundle => bundle?.option?.items?.find(item => item.materialNumber == activeSku?.materialNumber)), [bundles]);

    useEffect(() => {
        activeSku?.aemProdId && dispatch(fetchBundles([activeSku.aemProdId]));
    }, [activeSku?.aemProdId]);

    if (!target || !bundles || bundles.length === 0 || !isSkuInBundle || isSkuInBundle.length === 0 || !activeSku) {
        return null;
    }

    return ReactDOM.createPortal(<div className={"p-bundle-selector"}>
        <h4 className={"p-bundle-selector__header"}>
            {translate("Recommended products")} <PromoLabel code={bundles[0].promoCode}/>
        </h4>
        <div className={"p-bundle-selector__body"}>
            {bundles.map(bundle => ({...bundle, ...bundle.option})).map(bundle =>
                <OptionalBundleRow key={bundle.bundleId} materialNumber={activeSku.materialNumber}
                                   bundle={bundle} translate={translate} fallbackImage={fallbackImage}/>)}
        </div>
    </div>, target)
}
